import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { Button } from 'react-toolbox/lib/button'
import Body2 from 'components/typography/body2/index'
import Input from './Input'

import {
  applyQuery,
  updateQueryChanges,
  toggleDashboardQuery
} from './actions'
import {
  ProductHierarchyEnum,
  PartnerSiteEnum,
  AeRegionEnum
} from './constants'
import {
  queryChangesUiSelector as queryChangesSelector,
  querySourceSelector,
  reportsSelector
} from './selectors'
import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    reports: reportsSelector(state),
    queryChanges: queryChangesSelector(state),
    querySource: querySourceSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    applyQuery: (changes, reports) => dispatch(applyQuery(changes, reports)),
    updateQueryChanges: (type, value) => dispatch(updateQueryChanges(type, value)),
    toggleCollapse: () => dispatch(toggleDashboardQuery())
  }
}

class DashboardQuery extends Component {
  onApply = () => {
    const {
      applyQuery,
      queryChanges,
      reports,
      toggleCollapse
    } = this.props

    const combinedQueries = { ...PartnerSiteEnum, ...ProductHierarchyEnum, ...AeRegionEnum }
    const keys = Object.keys(combinedQueries)
    const queries = keys.map((key) => {
      const value = combinedQueries[key]
      const change = queryChanges(value)
      return {
        ...value,
        changes: change
      }
    })
    toggleCollapse()
    applyQuery(queries, reports)
  }

  updateQueryChanges = (type) => {
    return (values) => this.props.updateQueryChanges(type, values)
  }

  productHierarchy() {
    const {
      querySource,
      queryChanges,
    } = this.props

    const keys = Object.keys(ProductHierarchyEnum)
    return keys.map((key, index) => {
      const value = ProductHierarchyEnum[key]
      return (
        <Input
          key={index}
          title={value.label}
          source={querySource(value)}
          values={queryChanges(value)}
          multiSelectable={true}
          onChange={this.updateQueryChanges(value)}
        />
      )
    })
  }

  partnerSite() {
    const {
      querySource,
      queryChanges,
    } = this.props

    const keys = Object.keys(PartnerSiteEnum)
    return keys.map((key, index) => {
      const value = PartnerSiteEnum[key]
      return (
        <Input
          key={index}
          title={value.label}
          source={querySource(value)}
          values={queryChanges(value)}
          multiSelectable={true}
          onChange={this.updateQueryChanges(value)}
        />
      )
    })
  }

  aeRegion() {
    const {
      querySource,
      queryChanges
    } = this.props
    const keys = Object.keys(AeRegionEnum)
    return keys.map((key, index) => {
      const value = AeRegionEnum[key]
      const sources = querySource(value).map((source) => {
        return ({
          ...source,
          value: source.id
        })
      })
      return (
        <Input
          key={index}
          title={value.label}
          source={sources}
          values={queryChanges(value)}
          multiSelectable={true}
          onChange={this.updateQueryChanges(value)}
        />
      )
    })
  }

  render() {
    return (
      <Flex row='true' wrap styleName="dashboardQueryContainer">
        <Flex
          column
          auto
          styleName='dashboardQuery'
        >
          <Body2 styleName='filterTitle'>Filter by Product Hierarchy</Body2>
          {this.productHierarchy()}
        </Flex>
        <Flex
          column
          auto
          styleName='dashboardQuery'
        >
          <Body2 styleName='filterTitle'>Filter by Partner Site</Body2>
          {this.partnerSite()}
          <Body2 styleName='filterTitle'>Filter by AE Region</Body2>
          {this.aeRegion()}
        </Flex>
        <Button label="Apply" styleName='button' onClick={this.onApply} raised primary />
      </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(DashboardQuery)
